import {
  CustomerSocialMediaStatusEnum,
  CustomerSocialMediaStatusTypes,
  ICustomerSocialMediaStatusDTO,
} from "@hooks/dtos/customer/ICustomerSocialMediaDTO";

export const customerCustomerSocialMediaStatusTypes: ICustomerSocialMediaStatusDTO[] =
  [
    {
      status: CustomerSocialMediaStatusEnum.ACTIVE,
      name: "Ativo",
      description: "Este link de Perfil da Rede Social está ativa.",
      color: "success",
    },
    {
      status: CustomerSocialMediaStatusEnum.INACTIVE,
      name: "Inativo",
      description: "Este link de Perfil da Rede Social está inativa.",
      color: "warning",
    },
    {
      status: CustomerSocialMediaStatusEnum.DELETED,
      name: "Excluído",
      description: "Este link de Perfil da Rede Social está sendo criada.",
      color: "danger",
    },
  ];

export const getCustomerSocialMediaStatus = (
  status: CustomerSocialMediaStatusTypes,
): ICustomerSocialMediaStatusDTO => {
  let ret = customerCustomerSocialMediaStatusTypes.find(
    (customerCustomerSocialMediaStatusType) =>
      customerCustomerSocialMediaStatusType.status === status,
  );
  if (!ret)
    ret = { status: "x", name: "Error", description: "Error", color: "danger" };
  return ret;
};
